import React, { useState, useEffect } from 'react';
import EventCard from './EventCard';
import EventDetails from './EventDetails';
import LoaderExparel from '../LoaderExparel';
import useSiteMetadata from '@hooks/useSiteMetadata';


const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const { apiUrl } = useSiteMetadata();

  useEffect(() => {
    const fetchEvents = async () => {
      if (!apiUrl) return;

      try {
        const response = await fetch(`${apiUrl}/event`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        
        // Validate response structure
        if (!result || !Array.isArray(result.data?.events)) {
          throw new Error('Invalid response format from server');
        }
        
        setEvents(result.data.events);
        // Set the first event as selected by default
        if (result.data.events.length > 0) {
          setSelectedEvent(result.data.events[0]);
        }
      } catch (err) {
        setError('Error fetching events: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [apiUrl]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  if (loading) return (
    <div className="bg-gray-50 flex items-center justify-center">
		  <LoaderExparel />
    </div>
  );

  if (error) return (
    <div className="bg-gray-50 flex items-center justify-center">
      <div className="text-center text-paragraph text-red_error">Error: {error}</div>
    </div>
  );

  return (
    <div className="bg-gray-50 w-full">
      <div className="w-full sm:px-6">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[24px] lg:gap-0">
          {/* Events List Column */}
          <div style={{ maxHeight: '550px' }} className="flex flex-col">
					  <div className="grid grid-cols-1 pr-[30px] overflow-y-auto px-0 pt-2 space-y-4 justify-items-center lg:justify-items-start scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thin scrollbar-thumb-dark_green scrollbar-track-soft_green/70 hover:scrollbar-thumb-dark_green" style={{
						  maxHeight: '550px'
					  }}>
              {events.map(event => (
                <EventCard
                  key={event._id}
                  event={event}
                  isSelected={selectedEvent && selectedEvent._id === event._id}
                  onClick={handleEventClick}
                />
			  ))}
					  </div>
          </div>

          {/* Event Details Column */}
          <div style={{ maxHeight: '550px' }}>
            <EventDetails event={selectedEvent} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;
